import * as React from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import NavigationBar from "./components/navigation";
import LandingPage from "./pages/home";
import Event from "./pages/event";
import Footer from "./components/footer";
import { useAppDispatch } from "./helpers/hooks";
import { fetchToken } from "./features/authenticate/authSlice";
import { userProfile } from "./features/profile/userProfileSlice";
import { fetchProfileDetails } from "./features/profile/profileDetailsSlice";
import Loader from "./components/loader";
import ManageVolunteers from "./features/manageVolunteers/manageVolunteers";
import ManageEventForm from "./components/manageEvents/manageEventForm/ManageEventForm";
import CreateNewEvent from "./pages/createNewEvent";
//dynamic imports
const EventDetails = React.lazy(() => import("./pages/eventDetails"));
const Dashboard = React.lazy(() => import("./pages/dashboard"));
const FaqPage = React.lazy(() => import("./pages/faq"));
const Profile = React.lazy(() => import("./pages/profile"));
const Feedback = React.lazy(() => import("./components/event/feedback"));
const CheckInAttendance = React.lazy(() => import("./pages/attendance"));
import { ToastContainer } from "react-toastify";

function Pages() {
  return (
    <HashRouter>
      <ToastContainer toastStyle={{ backgroundColor: "#1E1E1E" }} />
      {window.location.pathname !== "/attendance" && <NavigationBar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/dashboard"
          element={
            <React.Suspense fallback={<Loader />}>
              <Dashboard />
            </React.Suspense>
          }
        />
        <Route
          path="/manage-volunteers"
          element={
            <React.Suspense fallback={<Loader />}>
              <ManageVolunteers />
            </React.Suspense>
          }
        />
        <Route path="/spocs" element={<LandingPage />} />
        <Route path="/volunteering-events" element={<Event />} />
        <Route
          path="/my-profile"
          element={
            <React.Suspense fallback={<Loader />}>
              <Profile />
            </React.Suspense>
          }
        />
        <Route
          path="/faq-and-guidelines/:id?"
          element={
            <React.Suspense fallback={<Loader />}>
              <FaqPage />
            </React.Suspense>
          }
        />
        <Route
          path="/event-details/eventId/:id"
          element={
            <React.Suspense fallback={<Loader />}>
              <EventDetails />
            </React.Suspense>
          }
        />
        <Route
          path="/feedback"
          element={
            <React.Suspense fallback={<Loader />}>
              <Feedback />
            </React.Suspense>
          }
        />
        
        <Route
          path="/manage-event"
          element={
            <React.Suspense fallback={<Loader />}>
              <CreateNewEvent key="create" />
            </React.Suspense>
          }
        />

        <Route
          path="/manage-event/:id"
          element={
            <React.Suspense fallback={<Loader />}>
              <CreateNewEvent key="edit" />
            </React.Suspense>
          }
        />
        <Route
          path="/attendance/:eventCode"
          element={
            <React.Suspense fallback={<Loader />}>
              <CheckInAttendance />
            </React.Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      {window.location.pathname !== "/attendance" && <Footer />}
    </HashRouter>
  );
}

export default function App() {
  const dispatch = useAppDispatch();
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [searchParams, setSearchParams] = React.useState(
    new URLSearchParams(window.location.search),
  );
  const currentUsershortId = localStorage.getItem("shortId") ?? "";
  React.useEffect(() => {
    if (!window.location.hash) {
      window.location.replace(window.location.href + "#/");
    }
  }, []);

  React.useEffect(() => {
    const loginTime = localStorage.getItem("loginTime");
    const sessionTime = Math.round(
      (Number(Date.now()) - Number(loginTime)) / 60000,
    );
    const token =
      sessionTime <= 30 ? localStorage.getItem("access_token") : null;
    if (!loggedIn && searchParams.size < 1 && token == null) {
      localStorage.setItem("redirect_after_login", window.location.href);
      window.location.href = `${process.env.REACT_APP_AUTH_URL}?response_type=code&client_id=${process.env.REACT_APP_SSO}&scope=${process.env.REACT_APP_AUTH_SCOPE}&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}`;
    } else if (
      !loggedIn &&
      searchParams &&
      searchParams.size == 1 &&
      searchParams.get("state") != null &&
      token == null
    ) {
      localStorage.setItem("redirect_after_login", window.location.href);
      window.location.href = `${
        process.env.REACT_APP_AUTH_URL
      }?response_type=code&client_id=${process.env.REACT_APP_SSO}&scope=${
        process.env.REACT_APP_AUTH_SCOPE
      }&state=${searchParams.get("state")}&redirect_uri=${
        process.env.REACT_APP_REDIRECT_URL
      }`;
    }
    if (localStorage.getItem("shortId")) {
      getProfileApiCall();
    }
  }, []);

  const getProfileApiCall = () => {
    dispatch(userProfile(currentUsershortId))
      .then((res) => {
        const profileData = res.payload;
        localStorage.setItem("userId", profileData.id);
        localStorage.setItem("userName", profileData.userName);
        localStorage.setItem("role", profileData.userType);
        if (res.meta.requestStatus === "fulfilled") {
          const redirect_url = localStorage.getItem("redirect_after_login");
          if (redirect_url) {
            setTimeout(() => {
              window.location.href = redirect_url;
            }, 500);
          }
        }
      })
      .catch((error) => {});
  };

  // React.useEffect(() => {
  //   if (currentUsershortId) {
  //     dispatch(userProfile(currentUsershortId));
  //   }
  // }, []);

  React.useEffect(() => {
    const code = searchParams.get("code");
    // const eventCode = searchParams.get("eventCode");
    const loginTime = localStorage.getItem("loginTime");
    const sessionTime = Math.round(
      (Number(Date.now()) - Number(loginTime)) / 60000,
    );
    const token =
      sessionTime <= 30 ? localStorage.getItem("access_token") : null;
    if (code) {
      searchParams.delete("code");
      // searchParams.delete("eventCode");
      setSearchParams(searchParams);
      const newSearch = searchParams.toString();
      const newUrl = `${window.location.pathname}${newSearch}${window.location.hash}`;
      window.history.replaceState({}, "", newUrl);
    }

    try {
      if (code) {
        dispatch(fetchToken(code)).then((res) => {
          setLoggedIn(true);
          const tokenObj = res.payload;
          localStorage.setItem("shortId", tokenObj.shortId);
          // localStorage.setItem("role", tokenObj.role);
          localStorage.setItem("access_token", tokenObj.access_token);
          localStorage.setItem("refresh_token", tokenObj.refresh_token);
          localStorage.setItem("expires_in", tokenObj.expires_in);
          localStorage.setItem("loginTime", Date.now().toString());
          dispatch(fetchProfileDetails(tokenObj.shortId));
          getProfileApiCall();
        });
      } else if (token != null) {
        setLoggedIn(true);
      }
    } catch (error) {}
  }, []);

  return <>{loggedIn && <Pages />}</>;
}
